export enum LoginPageScreen {
  HomeScreen,
  ResetPassword,
  UseCredentials,
  UseLoginEmail,
  LoginEmailSent,
  ResetPasswordEmailSent
}
